import { render } from "./AddSupplierComponent.vue?vue&type=template&id=513c0028"
import script from "./AddSupplierComponent.vue?vue&type=script&lang=js"
export * from "./AddSupplierComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__